
import { Component, Vue, Prop } from "nuxt-property-decorator";
import { HeaderData } from "~/types/components";

@Component({ name: "the-header-master" })
export default class TheHeader extends Vue {
  @Prop() headerdata!: HeaderData;
}
